export default __webpack_public_path__ + "images/choose-file-icon.svg";